module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.form) ? _c('div', [((this.localNew || this.isRequest) && this.form) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.providers,
      "border": "",
      "highlight-current-row": _vm.editMode,
      "max-height": "250"
    },
    on: {
      "current-change": _vm.checked
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.form.backhaul_id === _vm.providers[scope.$index].id) ? _c('i', {
          staticClass: "fa fa-check"
        }) : _c('i', {
          staticClass: "fa fa-nothing"
        })]
      }
    }], null, false, 597687970)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "backhaulType",
      "label": "Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provider.shortName",
      "label": "Provider"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "backhaul.exclusive",
      "label": "Exclusive"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          class: _vm.providers[scope.$index].exclusive ? 'fa fa-check-circle' : 'fa fa-minus-circle'
        })]
      }
    }], null, false, 3605889559)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "backhaul.depositFee",
      "label": "Entrance"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.formatNumber(_vm.providers[scope.$index].depositFee)) + "\n      ")]
      }
    }], null, false, 1829640494)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "backhaul.rightOfWayCharges",
      "label": "ROW"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.formatNumber(_vm.providers[scope.$index].rightOfWayCharges)) + "\n      ")]
      }
    }], null, false, 3913412727)
  })], 1) : _vm._e(), _vm._v(" "), (!this.form.site_id) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-alert', {
    attrs: {
      "type": "warning",
      "title": "Site Required",
      "description": "Please select a site to successfully save this provider.",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('select-site', {
    attrs: {
      "no-form": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.site_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "site_id", $$v)
      },
      expression: "form.site_id"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.organisation_id) ? _c('edit-pane', {
    ref: "bh",
    attrs: {
      "title": "Backhaul Customer",
      "editable": _vm.canAccess('finance|admin') && _vm.isTowerCo(),
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }, [_c('div', {
    staticClass: "padded"
  }, [_c('el-form', {
    attrs: {
      "label-position": this.isDesktop || this.isTablet ? 'top' : 'left',
      "label-width": "134px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('select-backhaul-status', {
    attrs: {
      "disabled": _vm.disabled && _vm.isTowerCo()
    },
    on: {
      "change": _vm.resetDates
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Entrance",
      "disabled": _vm.disabled && _vm.isTowerCo()
    },
    model: {
      value: (_vm.form.deposit),
      callback: function($$v) {
        _vm.$set(_vm.form, "deposit", $$v)
      },
      expression: "form.deposit"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Right of Way",
      "disabled": _vm.disabled && _vm.isTowerCo()
    },
    model: {
      value: (_vm.form.rightOfWay),
      callback: function($$v) {
        _vm.$set(_vm.form, "rightOfWay", $$v)
      },
      expression: "form.rightOfWay"
    }
  })], 1), _vm._v(" "), (_vm.localNew) ? _c('el-col', {
    staticClass: "bg-primary-lighten-1",
    staticStyle: {
      "border-radius": "8px"
    },
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Serivce Start",
      "placeholder": "Started",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.startService),
      callback: function($$v) {
        _vm.$set(_vm.form, "startService", $$v)
      },
      expression: "form.startService"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.status === 'Terminated') ? _c('el-col', {
    staticClass: "bg-danger-lighten-2",
    staticStyle: {
      "border-radius": "8px"
    },
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Terminated",
      "placeholder": "Terminated",
      "disabled": _vm.disabled && _vm.isTowerCo()
    },
    model: {
      value: (_vm.form.terminateService),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminateService", $$v)
      },
      expression: "form.terminateService"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.section),
      callback: function($$v) {
        _vm.section = $$v
      },
      expression: "section"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Contract")])]), _vm._v(" "), (_vm.form.started) ? _c('span', [_vm._v(": "), _c('b', [_vm._v(_vm._s(this.formatNumber(_vm.form.tenor, 0)))]), _vm._v(" yr. from "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.started)))]), _vm._v(" to "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.expiry)))])]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 9
    }
  }, [_c('text-input', {
    attrs: {
      "placeholder": "Contract No",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.contractNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "contractNo", $$v)
      },
      expression: "form.contractNo"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('date-input', {
    attrs: {
      "placeholder": "Started",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.started),
      callback: function($$v) {
        _vm.$set(_vm.form, "started", $$v)
      },
      expression: "form.started"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 20,
      "md": 9,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "placeholder": "Tenor"
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 1,
      "max": 24,
      "step": 1,
      "show-stops": "",
      "show-input": !_vm.localNew,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.tenor),
      callback: function($$v) {
        _vm.tenor = $$v
      },
      expression: "tenor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('el-form-item', [_c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.form.expiry)))]), _vm._v(" (" + _vm._s(_vm.formatDate(_vm.form.expiry)) + ")\n                ")])], 1)], 1)], 2), _vm._v(" "), (_vm.form.exclusive && _vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Exclusivity")])]), _vm._v(" "), (_vm.form.exclusiveExpiry) ? _c('span', [_vm._v(": expires on "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.exclusiveExpiry)))])]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Fee",
      "placeholder": "Fee",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.exclusiveFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "exclusiveFee", $$v)
      },
      expression: "form.exclusiveFee"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Expiry",
      "placeholder": "Expiry",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.exclusiveExpiry),
      callback: function($$v) {
        _vm.$set(_vm.form, "exclusiveExpiry", $$v)
      },
      expression: "form.exclusiveExpiry"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('select-frequency', {
    attrs: {
      "label": "Frequency",
      "placeholder": "Frequency",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.exclusiveFrequency),
      callback: function($$v) {
        _vm.$set(_vm.form, "exclusiveFrequency", $$v)
      },
      expression: "form.exclusiveFrequency"
    }
  })], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.form.deposit && _vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Deposit / Entrance")])]), _vm._v(" "), (_vm.form.depositPaid) ? _c('span', [_vm._v(": paid on "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.depositPaid)))])]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Entrance Fee",
      "placeholder": "Fee",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.depositFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "depositFee", $$v)
      },
      expression: "form.depositFee"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Date Paid",
      "placeholder": "Date Paid",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.depositPaid),
      callback: function($$v) {
        _vm.$set(_vm.form, "depositPaid", $$v)
      },
      expression: "form.depositPaid"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Ref",
      "placeholder": "Ref",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.depositRef),
      callback: function($$v) {
        _vm.$set(_vm.form, "depositRef", $$v)
      },
      expression: "form.depositRef"
    }
  })], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.form.rightOfWay && _vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Right of Way")])])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Right of Way",
      "placeholder": "ROW Charges",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.rightOfWayCharges),
      callback: function($$v) {
        _vm.$set(_vm.form, "rightOfWayCharges", $$v)
      },
      expression: "form.rightOfWayCharges"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Exclusive Fee",
      "placeholder": "Exclusive Fee",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.exclusiveFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "exclusiveFee", $$v)
      },
      expression: "form.exclusiveFee"
    }
  })], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.localNew) ? _c('el-collapse-item', {
    attrs: {
      "name": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Serivce")])]), _vm._v(" "), (_vm.form.startService) ? _c('span', [_vm._v(": from "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.startService)))]), (_vm.form.terminateService) ? _c('span', [_vm._v(" to "), _c('b', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.formatDate(_vm.form.terminateService)))])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Serivce Start",
      "placeholder": "Started",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.startService),
      callback: function($$v) {
        _vm.$set(_vm.form, "startService", $$v)
      },
      expression: "form.startService"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Terminated",
      "placeholder": "Terminated",
      "disabled": !_vm.editMode && (this.form.status == 'Active')
    },
    model: {
      value: (_vm.form.terminateService),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminateService", $$v)
      },
      expression: "form.terminateService"
    }
  })], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Sundry & Other Fees")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Recurring Fee",
      "placeholder": "Sundry Fees",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.recurringFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "recurringFee", $$v)
      },
      expression: "form.recurringFee"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('select-frequency', {
    attrs: {
      "label": "Frequency",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.frequency),
      callback: function($$v) {
        _vm.$set(_vm.form, "frequency", $$v)
      },
      expression: "form.frequency"
    }
  })], 1)], 2) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.form.updated_at) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.form.updated_at)))]), _vm._v(" (" + _vm._s(_vm.formatDateTime(_vm.form.updated_at)) + ")"), (_vm.form.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.form.updated_by))]) : _vm._e()])]) : _vm._e()]) : _c('div', {
    staticClass: "padded"
  }, [_c('el-alert', {
    attrs: {
      "title": "Sharer isn't a customer for this provider",
      "show-icon": "",
      "closable": false
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-413d1b28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backhaul/BackhaulCustomer.vue
// module id = 1446
// module chunks = 0